module.exports = __webpack_public_path__ + "static/1-ca6d00743ff475baf736f167f3d805a8.jpg";